import { compose } from 'recompose';
import FieldItem from './fieldItem';

const enhance = compose(
);
export default enhance(FieldItem);
